import { ApiError } from "@/server/request";
import { useToast } from "@chakra-ui/react";
import { TRPCClientError } from "@trpc/client";
import { TRPCError } from "@trpc/server";
import { camelCase } from "lodash";
import { useTranslations } from "next-intl";

const specialCase = (errorKey: string, errorMessage: string) => {
  if (errorKey === "coachId" && errorMessage === "expectedNumberReceivedNull")
    return "missingCoach";
  return null;
};

export const useToastifyError = () => {
  const t = useTranslations();
  const toast = useToast();
  const toastifyError = (e: any) => {
    console.warn(e);
    if (e instanceof TRPCClientError) {
      // @ts-ignore
      const error = e.meta?.responseJSON?.error;
      if (error?.code === 401) {
        console.error(e);
        toast({
          title: "Refreshing Session",
          description: "Please try again",
          status: "warning",
          duration: 3000,
          isClosable: true,
        });
        return;
      }

      if (e.message && e.message.includes("Db failure")) {
        toast({
          title: "Server Error",
          description: "Please try again later",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        return;
      }

      console.log("ERROR", error);

      let message = "";

      if (error.data.zodError?.fieldErrors) {
        const fieldErrors = error.data.zodError?.fieldErrors;
        for (const field of Object.keys(fieldErrors)) {
          const errorKey = fieldErrors[field][0] || "unexpected";
          const errorMessage = specialCase(field, camelCase(errorKey));
          let tField = "";
          try {
            tField = t(field);
          } catch (e) {
            tField = field;
          }
          message += errorMessage
            ? t("errors." + errorMessage)
            : `${tField}: ${t("errors." + camelCase(errorKey))}\n`;
        }
      } else {
        let translatedMessage = "";
        try {
          translatedMessage = t("errors." + camelCase(error.message));
        } catch (error) {
          translatedMessage = e.message;
        }
        message = translatedMessage;
      }
      toast({
        title: t("errors.title"),
        description: message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } else {
      let message = "";

      if (typeof e === "string") {
        message = e;
      } else if (e instanceof Error) {
        let translatedMessage = "";
        try {
          translatedMessage = t("errors." + camelCase(e.message));
        } catch (error) {
          translatedMessage = e.message;
        }
        message = translatedMessage;
      } else {
        message = e?.toString() || "Unknown error";
      }

      toast({
        title: t("errors.title"),
        description: message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }

    if (process.env.NODE_ENV === "development") {
      try {
        console.log(JSON.stringify(e));
      } catch (error) {
        // ignore
      }
    }
  };

  return { toastifyError };
};
